'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var touchStyles = {
    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    KhtmlUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none'
    //cursor: 'pointer'
};

exports.default = touchStyles;



//////////////////
// WEBPACK FOOTER
// ./~/react-tapper/lib/touch-styles.js
// module id = 565
// module chunks = 0